import { Box, CircularProgress, Typography } from "@material-ui/core";
import { usePopup } from "hooks/usePopup";
import { useState } from "react";
import batchConferenceService from "services/bachConferenceService";
import { Drawer } from "shared";
import { mapType } from "utils";

import { Form } from "../Form";
import { conferenceDataStyles } from "./styles";

export const ModalUpdate = ({
  conferenceData,
  isOpen,
  close,
  setPageToInitial,
  refreshData
}) => {
  const {
    batchInfos,
    received,
    quantityInvoice,
    quantity_invoice,
    batchConferenceId
  } = conferenceData;
  const classes = conferenceDataStyles();
  const { addPopup } = usePopup();
  const [isLoading, setIsLoading] = useState(false);

  const productUnit = mapType(batchInfos?.product?.purchase_type) || "unidade";

  const handleClose = () => {
    close();
  };

  const onSubmit = async data => {
    setIsLoading(true);
    try {
      await batchConferenceService.updateBatchConference(
        batchConferenceId,
        data
      );

      addPopup({
        type: "success",
        title: "Conferência atualizada com sucesso."
      });

      setPageToInitial();

      // Atualiza os dados da tabela em background
      if (refreshData) {
        refreshData();
      }

      // Pequeno delay para garantir transição suave
      setTimeout(() => {
        setIsLoading(false);
        handleClose();
      }, 300);
    } catch (error) {
      setIsLoading(false);
      addPopup({
        type: "error",
        title: "Erro ao atualizar conferência de recebimento."
      });
    }
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleClose}
      title="Conferência"
    >
      <Box style={{ position: "relative" }}>
        {isLoading && (
          <Box
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              backdropFilter: "blur(4px)"
            }}
          >
            <CircularProgress />
          </Box>
        )}

        {/* Conteúdo com blur quando loading */}
        <Box style={{ filter: isLoading ? "blur(2px)" : "none" }}>
          <Box className={classes.boxStyle}>
            <Box>
              <Typography className={classes.conferenceDataInfo}>
                Produto: <strong>{batchInfos?.product?.name}</strong>
              </Typography>
              <Typography className={classes.conferenceDataInfo}>
                Seller: <span>{batchInfos?.seller?.name}</span>
              </Typography>
              <Typography className={classes.conferenceDataInfo}>
                porção: <span>{productUnit}</span>
              </Typography>
            </Box>

            <hr style={{ width: "94%", marginTop: "1rem" }} />

            <Box>
              <Typography className={classes.conferenceDataInfo}>
                Recebido:{" "}
                <span>
                  {received || 0} {productUnit}
                </span>
              </Typography>
              <Typography className={classes.conferenceDataInfo}>
                Devolvido:{" "}
                <span>
                  {quantityInvoice || quantity_invoice || 0} {productUnit}
                </span>
              </Typography>
            </Box>
          </Box>

          <Form
            productUnit={productUnit}
            conferenceData={conferenceData}
            onSubmit={onSubmit}
          />
        </Box>
      </Box>
    </Drawer>
  );
};
